// extracted by mini-css-extract-plugin
export default {"current-rank":"CurrentRank_current-rank__l1Tvk","rank-1":"CurrentRank_rank-1__bMLWB","rank-2":"CurrentRank_rank-2__K0SwB","rank-3":"CurrentRank_rank-3__VIyjF"};